function SearchIcon({ ...rest }) {
  return (
    <svg
      width='21'
      height='21'
      viewBox='0 0 21 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M9.39886 17.1111C13.4851 17.1111 16.7977 13.7284 16.7977 9.55554C16.7977 5.38273 13.4851 2 9.39886 2C5.31258 2 2 5.38273 2 9.55554C2 13.7284 5.31258 17.1111 9.39886 17.1111Z'
        stroke='currentColor'
        strokeWidth='2.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18.6472 19.0009L14.624 14.8926'
        stroke='currentColor'
        strokeWidth='2.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export default SearchIcon;
